import { Typography } from "@mui/material";
import React from "react";

const Label = ({ children, ...otherProps }) => {
  return <Typography {...otherProps}>{children}</Typography>;
};

export default Label;
